import {useMemo} from 'react';
import {useBasket} from 'brandHooks';
import PaymentMethodsFactory from 'coreClasses/payments/PaymentMethodsFactory';
import type PaymentMethod from 'coreClasses/payments/paymentMethods/PaymentMethod';
import type {PaymentMethod as TPaymentMethod} from '../../store/data/basket/types';

/**
 * Returns express payment method instances applicable for specific section and product
 * @param {string} section - express payment button section to check applicability
 * @param {string} [productID] - product ID to check applicability
 * @returns {Array<PaymentMethod>} - array with payment method instances
 */
const useExpressPaymentMethods = (section: string, productID?: string): Array<PaymentMethod> => {
	const basket = useBasket();
	const paymentMethodObjects = basket?.applicablePaymentMethods || [];
	const expressPaymentMethods = useMemo(() => {
		const newExpressPaymentMethods = [];

		paymentMethodObjects.forEach((paymentMethodObjects: TPaymentMethod) => {
			const isSectionApplicable = paymentMethodObjects.c_expressButtons[section];

			if (isSectionApplicable) {
				const paymentMethod = PaymentMethodsFactory.create(paymentMethodObjects.id, paymentMethodObjects);

				if (paymentMethod.isApplicable(productID)) {
					newExpressPaymentMethods.push(paymentMethod);
				}
			}
		});

		return newExpressPaymentMethods;
	}, [paymentMethodObjects, section, productID]);

	return expressPaymentMethods;
};

export default useExpressPaymentMethods;
